import _get from 'lodash/get';
import theme from '../styles/themes/hopeTheme';
import findProductCartQty from '../components/_common/Utility/findProductCartQty';
import { subscriptionProductIdConstants } from '../../common/sharedConstants/subscriptionProductConstantsJS';

export const getNonEligibleSkuText = (product, c4cMode = '') => {
  const case4CauseDiscount = _get(
    product,
    'promoCodeDiscount.case4Cause.case6PriceUSD',
  );

  if (c4cMode && !case4CauseDiscount) {
    const isEligible = _get(
      product,
      'promoCodeDiscount.case4Cause.donationEligible',
    );
    switch (isEligible) {
      default:
        return '';
      case true:
        return `Eligible for 10% host donation, but no discounts.`;
      case false:
        return `Not eligible for discount or host donation`;
    }
  }
  return '';
};

export function currentPrice(
  product,
  viaQualifiedProductTotal,
  // c4cMode = '',
) {
  const hasPriceRange =
    product.parentProduct &&
    product.priceUSDmin &&
    product.priceUSDmax &&
    product.priceUSDmax !== product.priceUSDmin;
  const isSalePrice = product.priceSale !== null;
  // const case4CauseDiscount = _get(
  //   product,
  //   'promoCodeDiscount.case4Cause.case6PriceUSD',
  // );
  // const isCase4CauseActive =
  //   case4CauseActive &&
  //   case4CauseDiscount !== null &&
  //   case4CauseDiscount !== undefined;
  const isCase4CauseActive = false;
  switch (true) {
    case hasPriceRange: {
      const min = product.priceUSDmin.toFixed(2);
      const max = product.priceUSDmax.toFixed(2);
      const priceRange = `${min} - $${max}`;
      return { price: priceRange };
    }
    case isSalePrice:
      return {
        price: product.priceSale.toFixed(2),
        isSale: true,
        priceRetail: product.price.toFixed(2),
      };
    case isCase4CauseActive: {
      const {
        case12PriceUSD,
        case6PriceUSD,
      } = product.promoCodeDiscount.case4Cause;
      const cartModulo12 = viaQualifiedProductTotal % 12;
      const qualifiesDiscount18 = cartModulo12 === 6;
      const qualifiesDiscount30 =
        cartModulo12 === 0 && viaQualifiedProductTotal > 0;

      switch (true) {
        case qualifiesDiscount18:
          return {
            price: case6PriceUSD.toFixed(2),
            isSale: true,
            priceRetail: product.price.toFixed(2),
          };
        case qualifiesDiscount30:
          return {
            price: case12PriceUSD.toFixed(2),
            isSale: true,
            priceRetail: product.price.toFixed(2),
          };
        default:
          return {
            price: product.price.toFixed(2),
          };
      }
    }
    default:
      return {
        price: product.price.toFixed(2),
      };
  }
}

export const isPreferredCustomerProduct = product => {
  return product.productId === subscriptionProductIdConstants.preferredCustomer;
};

export const getButtonStyles = (user, product, c4cMode) => {
  if (!user || !user.cartV2) {
    return {
      color: 'white',
      backgroundColor: theme.hopeBlack,
      borderColor: theme.hopeBlack,
    };
  }

  const { viaQualifiedCartTotal } = user.cartV2;
  const isInCart = findProductCartQty(product.productId, user.cartV2.entries) > 0;
  const isDiscount30 = viaQualifiedCartTotal >= 12;
  const cartQty = viaQualifiedCartTotal % 12;

  // "Select Options" should always look the same even if in cart.
  if (isPreferredCustomerProduct(product)) {
    return {
      color: theme.hopeBlack,
      backgroundColor: 'white',
      borderColor: theme.hopeBlack,
    };
  }
  const case4CauseActive =
    !!(_get(product, 'promoCodeDiscount.case4Cause.case6PriceUSD'));
  if (!isInCart) {
    return {
      color: theme.hopeBlack,
      backgroundColor: 'white',
      borderColor: theme.hopeBlack,
    };
  }
  if (!case4CauseActive) {
    return {
      color: 'white',
      backgroundColor: theme.hopeBlack,
      borderColor: theme.hopeBlack,
    };
  }
  if (isDiscount30) {
    return {
      color: 'white',
      backgroundColor: theme.hopeToyBlue,
      borderColor: theme.hopeToyBlue,
    };
  }
  switch (cartQty) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      return {
        color: 'white',
        backgroundColor: theme.hopeBlack,
        borderColor: theme.hopeBlack,
      };
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
      return {
        color: 'white',
        backgroundColor: theme.hopeLightPurple,
        borderColor: theme.hopeLightPurple,
      };
    default:
      return {
        color: 'white',
        backgroundColor: theme.hopeBlack,
        borderColor: theme.hopeBlack,
      };
  }
};
